import React, { useState } from 'react'
import Wrapper from '../helpers/Wrapper'
import SectionHead from '../components/SectionHead'
import { Link, useNavigate } from 'react-router-dom'
import Input from '../components/Form Elements/Input'
import Button from '../ui/Button'
import LogError from '../components/LogError'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import AnimatePage from '../components/AnimatePage'
import { ChangePageTitle } from '../helpers/ChangeTitle'

function Login() {
    ChangePageTitle("Login")
    const [data, setData] = useState({
        email: "",
        password: ""
    })


    const navigate = useNavigate()

    // HandleInputChange

    const handleInput = (e) => {
        const { id, value } = e.target
        setData({ ...data, [id]: value })
    }

    // Login
    const { isPending, mutate, error } = useMutation({
        mutationFn: (formData) => {
            return apiClient.post('/auth/login', formData);
        },
        onSuccess: (res) => {
            navigate(`/`)
        }
    })

    const handleLogin = () => {
        mutate(data)
    }

    return (
        <AnimatePage>
            <div className='w-full relative mt-16'>
                <Wrapper>
                    <SectionHead
                        title="Login"
                        description="Access your account to track orders, manage your cart, and enjoy 
                                personalized shopping."
                    />

                    <LogError error={error} />

                    {/* Body */}

                    <div className="flex flex-col gap-5 lg:flex-row mx-auto max-w-7xl mt-14 lg:gap-24">
                        {/* Login Details */}
                        <div className="w-full">
                            <h1 className="text-xl lg:text-2xl font-medium">Login</h1>

                            <div className="mt-7 flex flex-col gap-5">
                                <label htmlFor="email" className='space-y-2'>
                                    <p>Email <small className='text-red-500'>*</small></p>
                                    <Input id="email" onChange={handleInput} value={data.email} />
                                </label>
                                <label htmlFor="password" className='space-y-2'>
                                    <p>Password <small className='text-red-500'>*</small></p>
                                    <Input id="password" type='password' onChange={handleInput} value={data.password} />
                                </label>
                                <Link to='/account/recovery' className='text-sm text-gray-500'>Forgot Password?</Link>
                                <Button onClick={handleLogin} fullWidth loading={isPending}>Log In</Button>
                            </div>
                        </div>

                        {/* New Customer */}
                        <div className="w-full">
                            <h1 className="text-xl lg:text-2xl font-medium">New Customer?</h1>
                            <p className='text-gray-500 mt-4'>Sign up for early Sale access plus tailored new arrivals, trends and promotions. To opt
                                out, click unsubscribe in our emails.
                            </p>
                            <Link
                                to='/account/register'
                                className='bg-black py-3 block w-full text-center mt-7 text-white text-sm rounded-full'
                            >
                                Register
                            </Link>
                        </div>

                    </div>

                </Wrapper>
            </div>
        </AnimatePage>
    )
}

export default Login